import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolders"><Path fillRule="evenodd" clipRule="evenodd" d="M12.3107 3H5V7H1V21H19V17H23V5H14.3107L12.3107 3ZM19 15.5H21.5V6.5H13.6893L11.6893 4.5H6.5V7H8.31066L10.3107 9H19V15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolders;
